/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CoverageStatusDto } from './CoverageStatusDto';
import {
    CoverageStatusDtoFromJSON,
    CoverageStatusDtoFromJSONTyped,
    CoverageStatusDtoToJSON,
} from './CoverageStatusDto';

/**
 * 
 * @export
 * @interface CoverageResponseDto
 */
export interface CoverageResponseDto {
    /**
     * List of operating areas with coverage status
     * @type {Array<CoverageStatusDto>}
     * @memberof CoverageResponseDto
     */
    areas: Array<CoverageStatusDto>;
    /**
     * Total operating areas assigned
     * @type {number}
     * @memberof CoverageResponseDto
     */
    totalAreas: number;
    /**
     * Number of areas covered
     * @type {number}
     * @memberof CoverageResponseDto
     */
    coveredAreas: number;
    /**
     * Number of areas not covered
     * @type {number}
     * @memberof CoverageResponseDto
     */
    uncoveredAreas: number;
}

/**
 * Check if a given object implements the CoverageResponseDto interface.
 */
export function instanceOfCoverageResponseDto(value: object): value is CoverageResponseDto {
    if (!('areas' in value) || value['areas'] === undefined) return false;
    if (!('totalAreas' in value) || value['totalAreas'] === undefined) return false;
    if (!('coveredAreas' in value) || value['coveredAreas'] === undefined) return false;
    if (!('uncoveredAreas' in value) || value['uncoveredAreas'] === undefined) return false;
    return true;
}

export function CoverageResponseDtoFromJSON(json: any): CoverageResponseDto {
    return CoverageResponseDtoFromJSONTyped(json, false);
}

export function CoverageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'areas': ((json['areas'] as Array<any>).map(CoverageStatusDtoFromJSON)),
        'totalAreas': json['totalAreas'],
        'coveredAreas': json['coveredAreas'],
        'uncoveredAreas': json['uncoveredAreas'],
    };
}

export function CoverageResponseDtoToJSON(value?: CoverageResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'areas': ((value['areas'] as Array<any>).map(CoverageStatusDtoToJSON)),
        'totalAreas': value['totalAreas'],
        'coveredAreas': value['coveredAreas'],
        'uncoveredAreas': value['uncoveredAreas'],
    };
}

